<template>
    <div class="grid">
      <!-- <loading
        :active="isLoadingModel"
        :can-cancel="true"
        color="#274461"
        :is-full-page="fullPage"
      ></loading> -->
      <div class="col-12">
        <div class="card">
      <Toast />

      <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
          <template #item="{ item, props }">
            <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
              <a :href="href" @click="navigate">
                <span :class="[item.icon, 'text-color']" />
                <span class="text-primary font-semibold">{{ item.label }}</span>
              </a>
            </router-link>
          </template>
        </Breadcrumb>
    </div>
      <!-- <div class="col-12 sticky">
        <div id="custom_card" class="card">
          <div class="grid justify-content-between">
            <div class="col-12 md:col-6">
              <div
                class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
              >
                <p style="color: #6b719b; font-size: 20px; font-weight: 800">
                  Categories
                </p>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div
                class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
              >
                <Button
                  iconPos="right"
                  label="Add"
                  icon="pi pi-plus"
                  v-tooltip.bottom="'Add'"
                  @click="add_cat"
                  size="small"
                  style="
                    box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                    border-color: #00b0b0 !important;
                    background-color: #00b0b0 !important;
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="card">
        <div class="col-12">
    
            <!-- <div class="card" id="custom_card"> -->
            <div class="grid p-fluid">
                <div class="col-12 md:col-12">
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-2">
                    <span class="p-float-label">
                        <InputText
                        format="text"
                        v-model="search_cat"
                        @input="get_list(1)"
                        >
                        </InputText>
                        <label>Search Category</label>
                    </span>
                    </div>
    
                    <div class="field col-12 md:col-2" v-if="user_type=='Super Admin'">
                    <span class="p-float-label">
                        <Dropdown
                        id="client_dropdown"
                        v-model="client_selected"
                        :options="client_dropdown"
                        :value="client_dropdown"
                        optionLabel="name"
                        filter
                        v-on:change="get_list(1)"
                        ></Dropdown>
                        <label for="Client">Client</label>
                    </span>
                    </div>
    
                </div>
                </div>
            </div>
    
            <div class="row">
                <div style="text-align: right; font-weight: bold ; font-size: 12px; margin-right: 35px;">
                    <span>Total Categories:</span>{{ dataviewValue.length }}
                </div>
            </div>  
            <!-- :rows="9" -->
            
            <DataView
                :value="dataviewValue"
                :layout="layout"
                :paginator="true"
                
                :rows="rowsPerPage"
                :sortOrder="sortOrder"
                :sortField="sortField"
            >
                <template #grid="slotProps">
                <div class="grid grid-nogutter" v-if="slotProps.items">
                    <div
                    class="col-12 md:col-4"
                    v-for="(item, index) in slotProps.items"
                    :key="index"
                    
                    >
                    <div
                        style="height: 120px"
                        class="card m-3 border-1 surface-border zoom"
                        id="custom_card_left"
                        @mouseover="showButtons(index)"
                        @mouseout="hideButtons(index)"
                        :style="{ 'border-left': '5px solid '+ item.color + ' !important' }"
                        
                    >
                        <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center">
                            <p
                            style="
                                color: #6b719b;
                                font-size: 20px;
                                font-weight: 600;
                                cursor: pointer;
                            "
                            @click="view_categories(item)"
                            >
                            {{ item.name }}
                            </p>
                        </div>
                        </div>
                        <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center">
                            <i class="pi pi-wallet" style="font-size: 1.5rem;color:#06ECE4"></i>&nbsp;
                            <p
                            style="
                                color: #6b719b;
                                font-size: 17px;
                                font-weight: 300;
                            "
                            >
                            {{ item.open_ticket }}/{{ item.allticket }} Tickets
                            </p>
                        </div>
                        </div>
    
                        <div class="flex justify-content-end">
                        <Button
                            v-show="showButton[index]"
                            class="p-button-rounded p-button-success p-button-text"
                            @click="edit_cat(item)"
                            icon="pi pi-pencil"
                            size="samll"
                        ></Button>
                        <!-- <Button
                            v-show="showButton[index]"
                            class="p-button-rounded p-button-danger p-button-text"
                            icon="pi pi-trash"
                            size="samll"
                            @click="confirmDeleteProduct(item)"
                        ></Button> -->
    
                        <!-- ------------ -->
    
                        <Button
                            v-show="showButton[index]"
                            class="p-button-rounded p-button-danger p-button-text"
                            icon="pi pi-trash"
                            size="samll"
                            @click="delete_toggle(item)"
                        ></Button>
    
                        <OverlayPanel ref="del" >
                                <div class="flex flex-column gap-3 w-25rem">
                                    <h5>Delete Category </h5>
    
                                    <div class="col-12">
                                    <div class="p-fluid formgrid grid">
                                        <div class="field col-12 md:col-12">
                                        <span class="p-float-label">
                                            <Textarea
                                                format="text"
                                                v-model="delete_remark"
                                            >
                                            </Textarea>
                                            <label>Remark</label>
                                        </span>
                                        </div>
    
                                        <div class="field col-12 md:col-4">
                                        <Button label="Delete" @click="delete_product"  class="p-button-primary btn_light_blue"/>
                                        </div>
                                        <div class="field col-12 md:col-4">
                                        <Button label="Cancel" @click="Cancel_delete"  class="p-button-danger btn_red"/>
                                        </div>
    
                                    </div>
                                    </div>
    
                                </div>
                            </OverlayPanel>
                        <!-- ------------ -->
                        </div>
                    </div>
                    </div>
                </div>
                <div
                    class="col-12 md:col-4"
                    v-else
                    >
                    <div
                        style="height: 120px"
                        class="card m-3 border-1 surface-border zoom"
                        id="custom_card_left"
                        @mouseover="showButtons(index)"
                        @mouseout="hideButtons(index)"
                        :style="{ 'border-left': '5px solid '+ slotProps.data.color + ' !important' }"
                        
                    >
                        <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center">
                            <p
                            style="
                                color: #6b719b;
                                font-size: 20px;
                                font-weight: 600;
                                cursor: pointer;
                            "
                            @click="view_categories(slotProps.data)"
                            >
                            {{ slotProps.data.name }}
                            </p>
                        </div>
                        </div>
                        <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center">
                            <i class="pi pi-wallet" style="font-size: 1.5rem;color:#06ECE4"></i>&nbsp;
                            <p
                            style="
                                color: #6b719b;
                                font-size: 17px;
                                font-weight: 300;
                            "
                            >
                            {{ slotProps.data.open_ticket }}/{{ slotProps.data.allticket }} Tickets
                            </p>
                        </div>
                        </div>
    
                        <div class="flex justify-content-end">
                        <Button
                            v-show="showButton[index]"
                            class="p-button-rounded p-button-success p-button-text"
                            @click="edit_cat(slotProps.data)"
                            icon="pi pi-pencil"
                            size="samll"
                        ></Button>
                        <!-- <Button
                            v-show="showButton[index]"
                            class="p-button-rounded p-button-danger p-button-text"
                            icon="pi pi-trash"
                            size="samll"
                            @click="confirmDeleteProduct(slotProps.data)"
                        ></Button> -->
    
                        <!-- ------------ -->
    
                        <Button
                            v-show="showButton[index]"
                            class="p-button-rounded p-button-danger p-button-text"
                            icon="pi pi-trash"
                            size="samll"
                            @click="delete_toggle(slotProps.data)"
                        ></Button>
    
                        <OverlayPanel ref="del" >
                                <div class="flex flex-column gap-3 w-25rem">
                                    <h5>Delete Category </h5>
    
                                    <div class="col-12">
                                    <div class="p-fluid formgrid grid">
                                        <div class="field col-12 md:col-12">
                                        <span class="p-float-label">
                                            <Textarea
                                                format="text"
                                                v-model="delete_remark"
                                            >
                                            </Textarea>
                                            <label>Remark</label>
                                        </span>
                                        </div>
    
                                        <div class="field col-12 md:col-4">
                                        <Button label="Delete" @click="delete_product"  class="p-button-primary btn_light_blue"/>
                                        </div>
                                        <div class="field col-12 md:col-4">
                                        <Button label="Cancel" @click="Cancel_delete"  class="p-button-danger btn_red"/>
                                        </div>
    
                                    </div>
                                    </div>
    
                                </div>
                            </OverlayPanel>
                        <!-- ------------ -->
                        </div>
                    </div>
                </div>
                </template>
            </DataView>
    
            <div class="per-page-and-pagination">
                <div class="per-page-dropdown">
                <label for="perPage">per page : </label>
                <Dropdown @change="window_up()" :options="perPageOptions" v-model="rowsPerPage" />
                </div>
            </div>
    
    
            
            
            <!-- </div> -->
        </div>
      </div>
      <Dialog
            v-model:visible="add_cat_model"
                :breakpoints="{'960px': '75vw'}"
            :style="{ width: '35vw' }"
            header="Add Categorie"
            :modal="true"
                position="top"
          >
          <div class="col-12">
            <div class="p-fluid formgrid grid" style="margin-top: 2%;">
              <div class="field col-12 md:col-12" style="margin-top: 1%;">
                <span class="p-float-label">
                  <InputText id="ticket_title" type="text" v-model="cat_title" />
                  <label for="name">Name</label>
                </span>
              </div>
              <div class="field col-12 md:col-12" style="margin-top: 1%;">
                <label for="cp-hex" class="font-bold block mb-2"> Color </label>
                <ColorPicker v-model="colorHEX" inputId="cp-hex" format="hex" class="mb-3" />
              </div>
            </div>
          </div>
  
          <template #footer>
                <Button label="Save" @click="save_cat" icon="pi pi-check" class="p-button-success"/>
              </template>
      </Dialog>
    </div>
</div>
  </template>
  <script>
  import apis from "@/apis";
  import axios from "axios";
  import BreadcrumbService from "../service/BreadcrumbService";
    
  export default {
    data() {
      return {
        breadcrumbHome: {},
        breadcrumbItems: [],
        BreadcrumbService: null,
        rowsPerPage:6,
        perPageOptions: [6, 12, 18, 1000],
        totalRecords:0,
        temp_product_id:"",
        delete_remark:"",
        search_cat:"",
        cat_title:"",
        colorHEX:"6b719b",
        isLoadingModel: false,
        fullPage: false,
        dataviewValue: [],
        layout: "grid",
        sortKey: null,
        sortOrder: null,
        sortField: null,
        user_type: "",
        client_id: "",
        showButton: [],
        add_cat_model:false,
        id:"",
  
        client_dropdown:[],
        client_selected:"",
        clientid:"",
      };
    },
    productService: null,
    watch:{
      // async rowsPerPage() 
      // {
      //   window.scrollTo({ top: 0, behavior: 'smooth' });
      // }
    } ,
    created() {
        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.getBreadcrum("Category", "/CategoryMaster")
        this.breadcrumbHome = Breadcrum_data.home;
        this.breadcrumbItems = Breadcrum_data.items;
    },
    async mounted() {
      this.user_type = localStorage.getItem("user_type");
      this.client_id = localStorage.getItem("client_id");
      await this.get_list();
      await this.getClientMaster();
    },
    methods: {
      window_up()
      {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      async view_categories(item)
      { 
        await localStorage.setItem('categoryDetails','');
        await localStorage.setItem('categoryDetails',JSON.stringify(item));
        this.$router.push({ name: "categoriesdetails" });
      },
      async confirmDeleteProduct(product) 
      {
        this.$confirm.require({
                  target: event.currentTarget,
                  message: 'Are you sure you want to Delete Category?',
                  icon: 'pi pi-exclamation-triangle',
                  accept: () => {
  
  
                      var payload=
                      {
                        "client_id":"65a4f82f6177e69880ece5d6",
                        // "user_id":localStorage.getItem("id"),
                        "user_id":"65a4d0a558b560c932b1b374",
                        "category_id":product._id
  
                      }
          
                      this.isLoadingModel = true;
                      var promise = apis.deleteCategory(payload);
                      promise.then((response) => {
                          this.isLoadingModel = false;
                          if (response.data.status==true) 
                          {
                              this.$swal(response.data.message);
                               this.get_list();
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                              
                          }
                          else
                          {
                              this.$toast.add({ severity: 'error', summary: 'ERROR!!!', detail: response.data.message, life: 3000 });
                          }
                      });
  
                  },
                  reject: () => {
                      this.$toast.add({ severity: 'error', summary: 'Cancel', detail: 'You have Cancelled', life: 3000 });
                  }
              });
          
      },
  
      delete_toggle(data) 
      { 
        this.temp_product_id=data._id;
        this.$refs.del.toggle(event);
      },
  
      delete_product(){
        if (this.delete_remark==null || this.delete_remark=="" || this.delete_remark==undefined) 
          {
            this.$toast.add({
                severity: "error",
                summary: "error",
                detail: "Please Enter Remark",
                life: 3000,
            });
            return false;
          }
  
        else
        {
          var payload=
          {
            "client_id":"65a4f82f6177e69880ece5d6",
            // "user_id":localStorage.getItem("id"),
            "user_id":"65a4d0a558b560c932b1b374",
            "category_id":this.temp_product_id,
            "remark":this.delete_remark
          }
  
          this.isLoadingModel = true;
          var promise = apis.deleteCategory(payload);
          promise.then((response) => {
              this.isLoadingModel = false;
              if (response.data.status==true) 
              {
                  this.$swal(response.data.message);
                    this.get_list();
                    this.temp_product_id="";
                    this.delete_remark="";
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  
              }
              else
              {
                  this.$toast.add({ severity: 'error', summary: 'ERROR!!!', detail: response.data.message, life: 3000 });
              }
          });
        }
      },
  
      Cancel_delete(){
        this.temp_product_id="";
        this.delete_remark="";
        this.$refs.del.hide();
      },
      async save_cat()
      {
        var name_regex = /^\s*$/;
  
        if (this.cat_title=="" || !this.colorHEX) 
        {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter category Name",
            life: 3000,
          });
          return false;
        }
  
        if (this.cat_title) 
        {   
            if (name_regex.test(this.cat_title)) 
            {
                this.$toast.add({
                severity: "error",
                summary: "error",
                detail: "Please Enter Valid Category Name",
                life: 3000,
              });
              return false;
            }                
        }
  
        var color = '#'+this.colorHEX;
        let details=
        {
            
            "client_id":"65a4f82f6177e69880ece5d6",
            "name":this.cat_title,
            "color":color,
            "status":"Active",
            // "user_id":localStorage.getItem("id"),
            "user_id":"65a4d0a558b560c932b1b374"
          }
        if (this.id) 
        {
          details['id']=this.id;
          
        } 
        
       
        this.isLoadingModel=true;
                  var promise = apis.categoryAddEdit(details);
                      promise.then((response) => {
              this.isLoadingModel=false;
                          this.$swal(response.data.message);
              this.add_cat_model=false;
              this.get_list();
              
                      });
      },
      async add_cat()
      { this.id="";
        this.cat_title ="";
        this.colorHEX  ="6b719b";
        this.add_cat_model=true;
      },
      async edit_cat(data)
      { 
        this.id=data._id;
        this.cat_title  = data.name;
        
        var color       = data.color;
        this.colorHEX   = color ? color.slice(1) : '6b719b';
  
        this.add_cat_model=true;
      },
      async getClientMaster() {
        var data = {
            limit: 10000,
            page_no: 1,
            count: false,
        };
       
        var promise = apis.getclientist(data);
        promise.then((response) => {
         this.client_dropdown = response.data.data;
        });
      },
      async get_list() {
        this.clientid = "";
        this.clientid = this.client_selected._id;
       
        if (this.clientid=='' || this.clientid==undefined) 
        {
          this.clientid=localStorage.getItem("client_id");
        }
  
        var data = {
          client_id: "65a4f82f6177e69880ece5d6",
          // client_id: this.clientid,
          search:this.search_cat,
        };
        this.isLoadingModel = true;
        var promise = apis.categoryListmaster(data);
        promise.then((response) => {
          this.isLoadingModel = false;
          this.dataviewValue = response.data.data;
        });
      },
      showButtons(index) {
        //this.$set(this.showButton, index, true);
        this.showButton[index] = true;
      },
      hideButtons(index) {
        //this.$set(this.showButton, index, false);
        this.showButton[index] = false;
      },
    },
  };
  </script>
  <style scoped >
  @import "../assets/demo/badges.scss";
  #custom_card {
    border-top: 3px solid #6b719b;
  }
  #custom_card_left {
   
    box-shadow:rgba(0, 0, 0, 0.1) 0px 8px 12px 0px !important;
  }
  .zoom {
    transform-origin: 0% 0% 1% 1%;
    transition: transform 1s, filter 1s ease-in-out;
  }
  /* The Transformation */
  .zoom:hover {
    transform: scale(1.1);
  }
  
  .border-info {
      border-left: 5px solid  #0dcaf0 !important;
  }
  
  .per-page-and-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  
  .per-page-dropdown {
    margin-right: 20px;
  }
  </style>
  